import { MatterBannerKind } from '@/matter/store/schemas'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { selectMatterById } from '@/matter/store/selectors'
import { isSampleMatter } from '@/matter/utils/is-sample-matter'
import { canEditMatterSettings } from '@/matter/utils/matter-permissions'
import { useAppSelector } from '@/store/store-hooks'
import { useMatterExternalSyncStatus } from '@/user_files/external-storage/hooks/useMatterExternalSyncStatus'

/**
 * Picks the drive-sync setup prompt a matter still needs, and returns the external sync state the
 * banner needs to act on it. Returns a `null` kind once the matter is fully set up, while the
 * status is still loading or errored, or when this viewer can't configure sync at all.
 */
export function useDriveSyncSetupBanner(matterId: string | null | undefined) {
  const matter = useAppSelector((state) => selectMatterById(state, { matterId }))

  // Sample matters cannot be synced to a drive folder.
  const available = !!matterId && canEditMatterSettings(matter) && kGetFeatureFlagStatus(kFeatureFlags.DRIVE_SYNC) && !isSampleMatter(matter)
  const { connectedAccount, hasActiveMatterSync, mapping, loading, error } = useMatterExternalSyncStatus({ matterId, enabled: available })

  let kind: MatterBannerKind.DriveSyncConnectFiles | MatterBannerKind.DriveSyncConnectFolder | null = null
  if (available && !loading && !error && !hasActiveMatterSync) {
    if (!connectedAccount) {
      kind = MatterBannerKind.DriveSyncConnectFiles
    } else {
      kind = MatterBannerKind.DriveSyncConnectFolder
    }
  }

  return { kind, loading, connectedAccount, mapping }
}
